import { MenuItem, TextField, TextFieldProps } from "@mui/material";
import { FieldValues, Path, UseFormRegister } from "react-hook-form";

type Option = {
    label: string;
    value: string | number;
};

type FormSelectFieldProps<T extends FieldValues> = {
    name: Path<T>;
    label: string;
    register: UseFormRegister<T>;
    options: Option[];
    errorMessage?: string;
} & Omit<TextFieldProps, "name" | "select">;

export function FormSelectField<T extends FieldValues>({
    name,
    label,
    register,
    options,
    errorMessage,
    ...rest
}: FormSelectFieldProps<T>) {
    return (
        <TextField
            select
            label={label}
            {...register(name)}
            error={!!errorMessage}
            helperText={errorMessage}
            fullWidth
            {...rest}
        >
            {options.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                    {option.label}
                </MenuItem>
            ))}
        </TextField>
    );
}